import baseRequest from 'queries/baseRequest';
import endpoints from 'consts/endpoints';

export const getBackendVersion = () => baseRequest({ path: endpoints.getAbout() });
